export function logger(...messages) {
  if (process.env.NODE_ENV !== 'production' || process.env.REACT_APP_ENV === 'staging') {
    console.log(...messages);
  }
}
